var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9963 20.0007C39.9963 30.102 32.5088 38.4529 22.782 39.808C21.8725 39.9341 20.942 40 19.9975 40C18.9072 40 17.8366 39.9131 16.794 39.7449C7.27172 38.2118 -0.00134277 29.9548 -0.00134277 20.0007C-0.00134277 8.95491 8.95335 0 19.9989 0C31.0444 0 39.9991 8.95491 39.9991 20.0007H39.9963Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10971 8.82031L17.3335 21.1526L8.05225 31.1796H10.1417L18.2682 22.4012L24.8335 31.1796H31.9426L22.2004 18.1536L30.8398 8.82031H28.7503L21.2671 16.905L15.2202 8.82031H8.11109H8.10971ZM11.1815 10.359H14.4467L28.8681 29.6408H25.6029L11.1815 10.359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.cb861ec675d598daad0de38505f2af8f.svg";
export { ForwardRef as ReactComponent };